module.exports = __webpack_public_path__ + "static/media/0024.2d0a69ba.svg";